module.exports = __webpack_public_path__ + "assets/fonts/navigation-menu.bbd619fd.svg";